/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  function isDrawerSizeLabel(label) {
    var normalized = String(label || '').replace(/:\s*$/, '').trim().toLowerCase();
    return normalized === 'size' || normalized === 'ring size' || normalized === 'us size' || normalized.indexOf('ring size') !== -1;
  }

  function buildCartDrawerMetaAccordion(meta) {
    if (!meta || meta.querySelector('.cart__item__meta-accordion')) return;

    var rows = Array.prototype.slice.call(
      meta.querySelectorAll(':scope > .cart__item__selected-options, :scope > .cart__item__property, :scope > .cart__item__selling-plan')
    );

    if (rows.length <= 1) return;

    var primaryRow = rows.find(function(row) {
      var label = row.querySelector('strong');
      return label && isDrawerSizeLabel(label.textContent);
    }) || rows[0];

    var secondaryRows = rows.filter(function(row) {
      return row !== primaryRow;
    });

    if (!secondaryRows.length) return;

    var details = document.createElement('details');
    details.className = 'cart__item__meta-accordion';

    var summary = document.createElement('summary');
    summary.className = 'cart__item__meta-toggle';
    summary.innerHTML = '<span class="cart__item__meta-toggle-label">More details</span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-nav-arrow-down" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

    var panel = document.createElement('div');
    panel.className = 'cart__item__meta-panel';

    secondaryRows.forEach(function(row) {
      panel.appendChild(row);
    });

    details.appendChild(summary);
    details.appendChild(panel);
    meta.appendChild(details);
  }

  function initCartDrawerMetaAccordions(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var metas = root.querySelectorAll('.drawer__items .cart__item__meta');

    metas.forEach(function(meta) {
      buildCartDrawerMetaAccordion(meta);
    });
  }

  function attachCartDrawerMetaObserver() {
    var holder = document.querySelector('#cart-drawer [data-items-holder]');
    if (!holder || holder.dataset.metaAccordionObserved === 'true') return;

    holder.dataset.metaAccordionObserved = 'true';

    var observer = new MutationObserver(function() {
      initCartDrawerMetaAccordions(document);
    });

    observer.observe(holder, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initCartDrawerMetaAccordions(document);
    attachCartDrawerMetaObserver();
  });

  document.addEventListener('shopify:section:load', function() {
    initCartDrawerMetaAccordions(document);
    attachCartDrawerMetaObserver();
  });


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
